/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "799c38253f0d6294c10db967bbd2d07db12cad4e";
